/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiJingleCollectionsIdJinglesQueryResponse, GetApiJingleCollectionsIdJinglesPathParams, GetApiJingleCollectionsIdJinglesQueryParams, GetApiJingleCollectionsIdJingles400, GetApiJingleCollectionsIdJingles401, GetApiJingleCollectionsIdJingles403, GetApiJingleCollectionsIdJingles404, GetApiJingleCollectionsIdJingles500 } from "../../types/GetApiJingleCollectionsIdJingles.ts";
import { getApiJingleCollectionsIdJinglesQueryResponseSchema } from "../../zod/JingleCollectionSchemas/getApiJingleCollectionsIdJinglesSchema.ts";

function getGetApiJingleCollectionsIdJinglesUrl({ id }: { id: GetApiJingleCollectionsIdJinglesPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/jingle-collections/${id}/jingles` as const }  
  return res
}

/**
 * @summary Получение джинглов
 * {@link /api/jingle-collections/:Id/jingles}
 */
export async function getApiJingleCollectionsIdJingles({ id, params }: { id: GetApiJingleCollectionsIdJinglesPathParams["Id"]; params?: GetApiJingleCollectionsIdJinglesQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiJingleCollectionsIdJinglesQueryResponse, ResponseErrorConfig<GetApiJingleCollectionsIdJingles400 | GetApiJingleCollectionsIdJingles401 | GetApiJingleCollectionsIdJingles403 | GetApiJingleCollectionsIdJingles404 | GetApiJingleCollectionsIdJingles500>, unknown>({ method : "GET", url : getGetApiJingleCollectionsIdJinglesUrl({ id }).url.toString(), params, ... requestConfig })  
  return getApiJingleCollectionsIdJinglesQueryResponseSchema.parse(res.data)
}